import { Box, Button, Card, CardContent, Stack, Typography } from "@mui/material";
import { useStyle } from "@features/Appointment/AppointmentBanner/style";
import { useAppointmentBanner } from "@features/Appointment/AppointmentBanner/useAppointmentBanner";
import { IAppointment } from "@modules/eirCustomersFacade/interfaces/models/IAppointment";

interface IParams {
    appointment: IAppointment;
    title: string;
    subTitle?: string;
    slot: string;
    date: string;
    buttonText?: string;
    onClick?: () => void;
}

export const AppointmentBanner = (props: IParams) => {
    const { appointment, title, slot, date, subTitle, buttonText, onClick } = props;

    const { isMobile, showButton } = useAppointmentBanner(appointment);

    const { classes } = useStyle();

    return (
        <Card className={classes.card} elevation={2} variant="outlined">
            <CardContent>
                <Stack direction={isMobile ? "column" : "row"} gap={1} justifyContent="space-between" margin={1}>
                    <Stack direction="column" gap={1} justifyContent="space-between">
                        <Typography color="secondary" fontWeight={900} variant="large">
                            {title}
                        </Typography>
                        <Typography color="secondary" fontWeight={450} variant="normal">
                            {subTitle ?? `${slot}, ${date}`}
                        </Typography>
                    </Stack>
                    {showButton && (
                        <Box alignItems="center" display="flex" justifyContent="center">
                            <Button color="primary" fullWidth={isMobile} variant="contained" onClick={onClick}>
                                {buttonText}
                            </Button>
                        </Box>
                    )}
                </Stack>
            </CardContent>
        </Card>
    );
};
